import script from "./FooterBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBox.vue?vue&type=script&setup=true&lang=js"

import "./FooterBox.vue?vue&type=style&index=0&id=9171fb4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9171fb4e"]])

export default __exports__